import React, { useState, useEffect } from 'react';

const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8003'
    : 'https://rbmchemicals.com';

const Gallery = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // cPanel domain ke hisab se live backend API URL
        fetch('https://rbmchemicals.com/api/get_gallery/')
            .then((res) => res.json())
            .then((data) => {
                if (Array.isArray(data)) {
                    setImages(data);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching gallery:", err);
                setLoading(false);
            });
    }, []);

    if (loading) return <div className="py-20 text-center text-xl">Loading Gallery...</div>;

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Banner Section */}
            <div className="relative h-[300px] w-full flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: "url('/banner-image.jpg')" }}>
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <h1 className="relative z-10 text-white text-5xl font-bold uppercase tracking-wider text-center px-4">Our Gallery</h1>
            </div>

            <section className="py-16 px-6 container mx-auto">
                <h2 className="text-3xl font-bold text-blue-900 mb-12 border-l-4 border-orange-500 pl-4">Project Gallery</h2>

                {images.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {images.map((item) => (
                            <div key={item.id} className="rounded-lg shadow-lg overflow-hidden border border-gray-200 hover:shadow-2xl transition-all duration-300">
                                <img
                                    src={item.image}
                                    alt="Gallery Project"
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-500"
                                    onError={(e) => { e.target.src = 'https://via.placeholder.com/300?text=Image+Not+Found'; }}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-center text-gray-500 text-xl">No images found.</p>
                )}
            </section>
        </div>
    );
};

export default Gallery;